<div class="qpx-skeleton-table-header" aria-hidden="true">
    @for (column of columnItems(); track column.index) {
        <qpx-skeleton height="0.75rem" [width]="column.width" />
    }
</div>

<div class="qpx-skeleton-table-body" aria-hidden="true">
    @for (row of rowItems(); track row) {
        <div class="qpx-skeleton-table-row">
            @for (column of columnItems(); track column.index) {
                <qpx-skeleton [width]="column.width" />
            }
        </div>
    }
</div>
